import { CommonModule } from '@angular/common';
import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  PermissionFeature,
  PermissionService,
} from '@price-management-console/permissions';
import { Tab } from '@price-management-console/shared-ui';

export interface HomeCard {
  id: string;
  titleKey: string;
  iconSrc: string;
  basePath: string;
  tabs: Tab[];
}

@Component({
  selector: 'app-home',
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './home.html',
  styleUrl: './home.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Home {
  private readonly permissions = inject(PermissionService);

  homeCards = computed<HomeCard[]>(() => {
    const cards: HomeCard[] = [];

    if (this.permissions.hasFeatureAccess(PermissionFeature.RateManagement)) {
      cards.push({
        id: 'rate-management',
        titleKey: 'RATE_MANAGEMENT.TITLE',
        iconSrc: 'images/rates.svg',
        basePath: '/rate-management',
        tabs: [
          {
            label: 'RATE_MANAGEMENT.PUBLICATIONS',
            disabled: false,
            path: 'publications',
          },
          {
            label: 'RATE_MANAGEMENT.ACTIVITY_LOG',
            disabled: true,
            path: 'activity-log',
          },
        ],
      });
    }

    if (this.permissions.hasFeatureAccess(PermissionFeature.RoutingProtocol)) {
      const hasAccess = this.permissions.hasFeatureAccess(
        PermissionFeature.RoutingProtocol
      );
      cards.push({
        id: 'routing-protocol',
        titleKey: 'ROUTING_PROTOCOL.TITLE',
        iconSrc: 'images/icon-track.svg',
        basePath: '/routing-protocol',
        tabs: [
          {
            label: 'ROUTING_PROTOCOL.ROUTING_PROTOCOLS',
            disabled: !hasAccess,
            path: 'protocols',
          },
          {
            label: 'ROUTING_PROTOCOL.PROTOCOL_GROUPS',
            disabled: !hasAccess,
            path: 'groups',
          },
          {
            label: 'ROUTING_PROTOCOL.STATIONS',
            disabled: !hasAccess,
            path: 'stations',
          },
          {
            label: 'ROUTING_PROTOCOL.EXCEPTIONS',
            disabled: !hasAccess,
            path: 'exceptions',
          },
          {
            label: 'ROUTING_PROTOCOL.JUNCTION_SYNONYMS',
            disabled: !hasAccess,
            path: 'junction-synonyms',
          },
        ],
      });
    }
    return cards;
  });
}
